import React from 'react';
import './styles/omside.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ArtikelSektion from '../../components/artikelsektion';
import Testimonials from '../../components/testimonials';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';
import markImage from '../../images/os/mark-pb.webp';
import nicolaiImage from '../../images/os/nicolai-pb.webp';

const OmOsHero = () => {
  return (
    <section className="omside-hero">
      <div className="container">
        <div className="omside-hero-content">
          <div className="omside-hero-text">
            <div className="omside-hero-badge">
              <span>Eksperter i webdesign og SEO siden 2021</span>
            </div>
            <h1 className="omside-hero-title">
              <span className="omside-hero-accent">Ordentlighed.</span> Resultater. Partnerskab.
            </h1>
            <p className="omside-hero-description">
              Det er grundlaget for Parla Branding. Vi er et passioneret team, der tror på, at de stærkeste digitale løsninger kommer fra et tæt samarbejde og en stolthed i håndværket.
              <br /><br />
              For os handler det ikke om at være de største, men om at gøre den største forskel for de kunder, vi arbejder med.
            </p>
            <div className="omside-hero-stats">
              <div className="omside-hero-stat">
                <div className="omside-hero-stat-number">100+</div>
                <div className="omside-hero-stat-label">Hjemmesider skabt</div>
              </div>
              <div className="omside-hero-stat">
                <div className="omside-hero-stat-number">4.8★</div>
                <div className="omside-hero-stat-label">Google rating</div>
              </div>
              <div className="omside-hero-stat">
                <div className="omside-hero-stat-number">2021</div>
                <div className="omside-hero-stat-label">Etableret</div>
              </div>
            </div>
            <div className="omside-hero-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/priser"
                icon={<CTAIkoner.ArrowRight />}
              >
                Se vores priser
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="tel:+4536170000"
                icon={<CTAIkoner.Phone />}
              >
                Ring til os
              </CTAKnap>
            </div>
          </div>
          <div className="omside-hero-visual">
            <div className="omside-hero-image">
              <div className="omside-hero-floating-element omside-hero-element-1">
                <span className="omside-hero-element-text">Kreativt Design</span>
              </div>
              <div className="omside-hero-floating-element omside-hero-element-2">
                <span className="omside-hero-element-text">SEO Optimering</span>
              </div>
              <div className="omside-hero-floating-element omside-hero-element-3">
                <span className="omside-hero-element-text">Hurtig Levering</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const OmOsTeam = () => {
  const teamMembers = [
    {
      name: "Mark Abildgaard Christensen",
      role: "Medstifter & CEO",
      description: "Webdesign ekspert flere års erfaring inden for digitale løsninger og brugeroplevelse.",
      image: markImage,
      linkedin: "https://www.linkedin.com/in/mark-christensen-052247273/",
      specialties: ["Webdesign", "UX/UI", "Strategi"],
      quote: "Jeg har en passion for at skabe design og brugeroplevelser, som rykker i takt med de nye standarder inden for internettet. Du kan roligt lægge den opgave i mine hænder, velvidende at jeg tager mig af det, som om det var min egen baby."
    },
    {
      name: "Nicolai Malik Jeppesen",
      role: "Medstifter & CTO",
      description: "SEO ekspert der sikrer at alle hjemmesider rangerer på Google.",
      image: nicolaiImage,
      linkedin: "https://www.linkedin.com/in/nicolai-malik-jeppesen/",
      specialties: ["SEO", "Google Ads", "Automatiseringer"],
      quote: "SEO handler for mig om at forstå mennesker - ikke bare algoritmer. Det gælder om at være til stede, når folk leder efter noget, de faktisk har brug for. Jeg nørder det tekniske, så alt spiller i kulissen, men det vigtigste er stadig at ramme rigtigt på det rigtige tidspunkt."
    }
  ];

  return (
    <section className="omside-team">
      <div className="container">
        <div className="omside-team-header">
          <h2 className="omside-team-title">Mød holdet bag Parla Branding</h2>
          <p className="omside-team-description">
            Navnet er ingen tilfældighed. Vi tror på, at en hjemmeside i dag er meget mere end en digital brochure – den er hjertet i din virksomheds branding.

Det er her, potentielle kunder danner deres første, afgørende indtryk. Vores opgave – og vores passion – er at sikre, at det indtryk er professionelt, tillidsvækkende og afspejler den kvalitet, din virksomhed står for.
          </p>
        </div>
        <div className="omside-team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="omside-team-member">
              <div className="omside-team-member-image">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="omside-team-member-content">
                <h3 className="omside-team-member-name">{member.name}</h3>
                <p className="omside-team-member-role">{member.role}</p>
                <p className="omside-team-member-description">{member.description}</p>
                <div className="omside-team-member-quote">
                  <p className="omside-team-quote-text">{member.quote}</p>
                </div>
                <div className="omside-team-member-specialties">
                  {member.specialties.map((specialty, i) => (
                    <span key={i} className="omside-team-member-specialty">
                      {specialty}
                    </span>
                  ))}
                </div>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="omside-team-linkedin">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const OmOsVaerdier = () => {
  const values = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
        </svg>
      ),
      title: "En hurtig hjemmeside, dine kunder gider bruge",
      description: "En langsom hjemmeside er den hurtigste vej til at miste en kunde. Vi bygger et let og effektivt fundament uden unødvendig \"fyld\", så dine besøgende får en god og hurtig oplevelse.",
      metric: "✓ Bedre brugeroplevelse"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
      ),
      title: "Bygget til at blive fundet på Google",
      description: "Synlighed på Google starter med et korrekt teknisk fundament. Fra allerførste linje kode bygger vi din side, så Google nemt kan forstå, hvad den handler om, og vise den til de rigtige kunder.",
      metric: "✓ Solid start på Google"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: "Et design, der guider dine kunder",
      description: "Et flot design skal have et formål. Vi designer din hjemmeside, så den ikke kun er pæn, men også intelligent guider dine besøgende til at tage kontakt, lægge en ordre eller bede om et tilbud.",
      metric: "✓ Flere kundehenvendelser"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M8 12l2 2 4-4"/>
        </svg>
      ),
      title: "En klar proces og en aftalt deadline",
      description: "Vi respekterer din tid og din investering. Vores gennemtestede proces sikrer, at vi når i mål til den aftalte tid – uden overraskelser eller at gå på kompromis med kvaliteten af vores håndværk.",
      metric: "✓ Levering til tiden"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="10" rx="2" ry="2"/>
          <circle cx="12" cy="16" r="1"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      ),
      title: "Sikkerhed og tryghed i hverdagen",
      description: "Sov trygt om natten. Vi tager os af alt det tekniske med sikkerhedscertifikater, faste backups og løbende overvågning, så din hjemmeside altid er stabil, sikker og online.",
      metric: "✓ Din digitale livsforsikring"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: "Du taler med os – ikke med en robot",
      description: "Hos os taler du direkte med de specialister, der rent faktisk bygger din løsning. Ingen upersonlige supportkøer eller projektledere som mellemled. Vi er her for dig, hele vejen.",
      metric: "✓ Personlig og direkte kontakt"
    }
  ];

  return (
    <section className="omside-vaerdier">
      <div className="container">
        <div className="omside-vaerdier-header">
          <h2 className="omside-vaerdier-title">Hvorfor vælge os som jeres digitale partner?</h2>
          <p className="omside-vaerdier-description">
            Vi ved, der er mange at vælge imellem. Vi adskiller os ved at være mere end bare leverandører – vi er jeres personlige, digitale partner. Vores løfte er at kombinere solidt håndværk med en ægte interesse i jeres forretnings succes.
          </p>
        </div>
        <div className="omside-vaerdier-grid">
          {values.map((value, index) => (
            <div key={index} className="omside-vaerdier-item">
              <div className="omside-vaerdier-icon">
                {value.icon}
              </div>
              <h3 className="omside-vaerdier-item-title">{value.title}</h3>
              <p className="omside-vaerdier-item-description">{value.description}</p>
              <div className="omside-vaerdier-metric">{value.metric}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};



const OmOsSide = () => {
  // Struktureret data for organisationen
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Parla Branding",
    "description": "Professionelle hjemmesider og webdesign for virksomheder i Holbæk og omegn",
    "url": "https://www.parlabranding.dk",
    "logo": "https://www.parlabranding.dk/images/logo/parla-logo.webp",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+45-36-17-00-00",
      "contactType": "customer service"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "DK",
      "addressLocality": "Holbæk",
      "addressRegion": "Sjælland"
    },
    "sameAs": [
      "https://dk.linkedin.com/company/parlabranding",
      "https://www.facebook.com/ParlaBranding/"
    ]
  };

  return (
    <div className="omside-page">
      <SEO 
        title="Om Os | Mød Holdet Bag Parla Branding"
        description="Vi er et dansk webbureau med en urokkelig tro på kvalitet og et tæt partnerskab. Læs historien om, hvorfor vi er dedikerede til det gode, digitale håndværk."
        keywords="om parla branding, webdesign team, dansk webbureau, digitalt håndværk, kvalitet partnerskab, hjemmeside specialister"
        url="https://www.parlabranding.dk/omos"
        canonicalUrl="https://www.parlabranding.dk/omos"
      />
      
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema)
        }}
      />
      
      <Header />
      <main className="omside-main">
        <OmOsHero />
        <OmOsTeam />
        <Testimonials 
          hideOmOsButton={true}
          customSecondButton={
            <CTAKnap 
              variant="outline" 
              size="large"
              href="/priser"
              icon={<CTAIkoner.BarChart />}
            >
              Se vores priser
            </CTAKnap>
          }
        />
        <OmOsVaerdier />
        <ArtikelSektion 
          hideOmOsButton={true}
          customFirstButton={
            <CTAKnap 
              variant="primary" 
              size="large"
              href="/artikler"
              icon={<CTAIkoner.FileText />}
            >
              Vores artikler
            </CTAKnap>
          }
          customSecondButton={
            <CTAKnap 
              variant="outline" 
              size="large"
              href="/kontakt"
              icon={<CTAIkoner.Phone />}
            >
              Kontakt os
            </CTAKnap>
          }
        />
      </main>
      <Footer />
    </div>
  );
};

export default OmOsSide;
